import { render, staticRenderFns } from "./basket-preorder-warning.vue?vue&type=template&id=5e128774"
import script from "./basket-preorder-warning.vue?vue&type=script&lang=js"
export * from "./basket-preorder-warning.vue?vue&type=script&lang=js"
import style0 from "./basket-preorder-warning.vue?vue&type=style&index=0&id=5e128774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
